import React, { Component } from "react";

class Socials extends Component {
  icons = [];

  render() {
    return (
      <div className="rs-icons">
        {this.props.icons.length > 0 &&
          this.props.icons.map((icon, index) => (
            <a
              key={index}
              href={icon.link}
              target="_blank"
              rel="noopener noreferrer"
            >
                <img src={icon.image_link} alt="" />
            </a>
          ))}
      </div>
    );
  }
}

export default Socials;
